import {
    FETCH_COURSE_NAME_FAILURE,
    FETCH_COURSE_NAME_REQUEST,
    FETCH_COURSE_NAME_SUCCESS,
  } from '../constants/actionTypes'
  
  import { fetchRequestWithHeader } from '../utils/fetchRequest'
  import { serviceEndPoint } from '../utils/serviceEndPoint'
  
  export const getCourse = async (dispatch, jwtToken, pincode, pincodeErrors) => {
    dispatch({ type: FETCH_COURSE_NAME_REQUEST })
    let requestFormData = new FormData()
    requestFormData.append(
      'data',
      '{"token" : "", "action" : "findall", "data" : [{}]}'
    )
    let response = { data: '[]' }
    if (pincode.length === 6 && pincodeErrors === 0) {
      return await fetchRequestWithHeader(
        serviceEndPoint.courseServiceEndPoint,
        requestFormData,
        jwtToken.token
      )
        .then(response => {
          // console.log(response)
          dispatch({ type: FETCH_COURSE_NAME_SUCCESS, response })
        })
        .catch(() =>
          Promise.reject(dispatch({ type: FETCH_COURSE_NAME_FAILURE, response }))
        )
    } else {
      dispatch({ type: FETCH_COURSE_NAME_FAILURE, response })
    }
  }